export default {
    navigationBarTitleText: '户型库'
  };
  